import { render } from "./TagPage.vue?vue&type=template&id=d8d13c72"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__